import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PersonelDetailsData from './PersonelDetailsData';

function PersonelDetails(props) {
    const { layout } = props;

    let content;
    if (layout === 'classic') {
        content = (
            <PersonelDetailsData layout={layout} />
        );
    } else if (layout === 'full') {
        content = (
            <PersonelDetailsData layout={layout} />
        );
    }

    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
}

PersonelDetails.propTypes = {
    layout: PropTypes.oneOf(['classic', 'full']),
};

PersonelDetails.defaultProps = {
    layout: 'classic',
};
const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(PersonelDetails);
